// extracted by mini-css-extract-plugin
export default {"doc":"doc___Fmp3M","content":"content___JF4zH"};